import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

interface FormularySearchParams {
  searchTerm: string;
  partnerUid?: string;
  snomedCode?: string;
}

interface FormularySearchResponse {
  items: FormularySearchResponse_Item[];
}

export type FormularyDrugCodings = {
  code: string;
  codeSystem: string;
};

export type OrderSentence = {
  daysSupply: number;
  directions: string;
  dispenseQuantity: number;
  dispenseQuantityUnitId: string;
  dispenseQuantityUnit: {
    coding: {
      code: string;
      system: string;
      display: string;
    }[];
    text: string;
  };
  noteToPharmacy: string;
  refills: number;
  substitutionAllowed: boolean;
};

interface FormularySearchResponse_Item {
  drugName: string;
  medicationName: string;
  strength: string;
  orderSentence: OrderSentence | null;
  drugCodes: FormularyDrugCodings[];
}

export const useFormularySearch = (params: FormularySearchParams) => {
  return useApi<FormularySearchResponse>({
    queryOptions: {
      enabled: true,
      queryFn: async () => {
        const response = await axiosInstance.get<FormularySearchResponse>(
          "/rx/formulary/search",
          { params },
        );

        return response.data;
      },
      queryKey: QueryKeys.Reference.Formulary.Search.DEFAULT(params),
    },
  });
};
